import { useLang } from "./LangContext";

export default function Marquee() {
  const { t } = useLang();
  const strip = (hidden) => (
    <div className="marquee-set" aria-hidden={hidden || undefined}>
      {t.marquee.map((item) => (
        <span className="marquee-item" key={item}>
          {item}
          <span className="diamond" aria-hidden="true">
            ◆
          </span>
        </span>
      ))}
    </div>
  );

  return (
    <div className="marquee" data-testid="marquee">
      <div className="marquee-track">
        {strip(false)}
        {strip(true)}
      </div>
    </div>
  );
}
